function AuditoriaContinuaShareController($scope, promiseTracker, httpService, api) {

    var ctrl = this,
        token = window.location.pathname.split('/').last();

    httpService.disableAutoLogOff();

    ctrl.loadingTracker = promiseTracker();
    ctrl.pagination = {};
    ctrl.dadosLink = {};
    ctrl.filtro = {};

    $scope.$watch('ctrl.filtro', function(){
        cbk.search(function(){
            ctrl.loadData()
        })()
    }, true);

    ctrl.$onInit = () => {
        pageSetUp()

        ctrl.loadingTracker.addPromise(
            api.get('/auditoria-tributaria/estoque/link/' + token)
                .then(function(response) {
                    ctrl.dadosLink = response.data.link;
                    ctrl.cstCsosn = ctrl.dadosLink.filial.simples_nacional_icms ? 'CSOSN' : 'CST';
                })
        );
    }

    ctrl.show = function(campo) {
        return ctrl.dadosLink.campos.includes(campo)
    };

    var showAny = function(campos) {
        return campos.some(ctrl.show)
    };

    ctrl.showPis = function() {
        return showAny(['estoque_aliquota_pis', 'auditoria_aliquota_pis', 'estoque_cst_pis', 'auditoria_cst_pis'])
    };

    ctrl.showCofins = function() {
        return showAny(['estoque_aliquota_cofins', 'auditoria_aliquota_cofins', 'estoque_cst_cofins', 'auditoria_cst_cofins'])
    };

    ctrl.showIcms = function() {
        return showAny(['estoque_aliquota_icms', 'auditoria_aliquota_icms', 'estoque_cst_icms', 'auditoria_cst_icms'])
    };

    ctrl.loadData = function(page) {
        page = page || 1;
        var params = {page: page};
        if (typeof(ctrl.filtro.revisado) === "boolean")
            params.revisado = ctrl.filtro.revisado;

        if (ctrl.filtro.busca)
            params.busca = ctrl.filtro.busca;

        ctrl.loadingTracker.addPromise(
            api.get('/auditoria-tributaria/estoque/share/'+token, params)
              .then(function(response) {
                ctrl.pagination = {
                  page: response.data.page,
                  total: response.data.total_pages,
                  perPage: 1
                };
                ctrl.count = response.data.count;
                ctrl.listOfDivergencias = response.data.items
              })
        )
    };

    ctrl.revisar = function(auditoria) {
        api.put('/auditoria-tributaria/estoque/share/'+token, {estoque_id: auditoria.id})
          .then(function() {
            auditoria.revisado = !auditoria.revisado
          })
    };

    ctrl.msgCsosn101 = "NT 2015/03, quando o destinatário for contribuinte do ICMS, utilizar os CSOSN de ICMS previstos na regra de validação da Sefaz, que são 101, 103, 300, 400 e 500.\n"
        + "NT 2015/03, quando o destinatário for não contribuinte do ICMS (indIEDest = 9), utilizar os CSOSN de ICMS previstos na regra de validação da Sefaz, que são 102, 103, 300, 400 e 500.";

    ctrl.getTipoAlerta = function(divergencia, tipo) {
        var a_entrada, a_saida, e_entrada, e_saida, ref, ref1;
        if (divergencia.estoque[tipo] != null) {
            if (tipo == 'cst_pis' || tipo == 'cst_cofins') {
                ref = divergencia.estoque[tipo].split('/'), e_entrada = ref[0], e_saida = ref[1];
                ref1 = divergencia.auditoria[tipo].split('/'), a_entrada = ref1[0], a_saida = ref1[1];
                if ((e_entrada == '--' || e_entrada == a_entrada) && (e_saida == '--' || e_saida == a_saida)) {
                    return 'warning';
                } else {
                    return 'danger';
                }
            } else {
                return 'danger';
            }
        } else {
            return 'warning';
        }
    };
}

angular.module('eficienciaFiscalModule')
    .controller('auditoriaContinuaShareController', ['$scope', 'promiseTracker', 'httpService', 'api', AuditoriaContinuaShareController]);
